<template>
    <div class="max-w-full mx-auto lg:max-w-4xl px-12 mb-8">
        <div class="md:flex">
            <div class="w-full md:w-1/2 p-4 h-auto flex items-center justify-center">
                <img :src="getImageUrl" alt="vase">
            </div>
            <div class="addon--container--content">
                <div class="addon--container--content--text">
                    <h2 v-if="isChecked" class="addon--container--content--text--title"
                        v-html="$t('FREDDIES_ADDONS_LIKE_A_FREE_VASE', {vaseName})"/>
                    <h2 v-else class="addon--container--content--text--title"
                        v-html="$t('FREDDIES_ADDONS_LIKE_A_VASE', {
                        'firstName': $t(`${firstName}`) })"/>
                    <div v-if="isBumperSelected">
                        <p v-text="$t('FREDDIES_ADDONS_WE_HAVE_DESIGNED')"></p>
                        <p v-text="$t('FREDDIES_ADDONS_BEAUTIFUL')"></p>
                    </div>
                    <p v-if="isPopSelected" v-text="$t('FREDDIES_ADDONS_POP_BOX')"></p>
                    <p v-if="!isBumperSelected && !isPopSelected" v-text="$t('FREDDIES_ADDONS_BEAUTIFUL')"></p>
                </div>
                <div class="addon--container--content--action">
                        <div class="addon--container--content--action--select">
                            <input type="checkbox"
                                   v-model="paidVase"
                                   :disabled="isChecked"
                                   class="addon--container--content--action--select--input">
                            <p @click="paidVase = !paidVase"
                               class="addon--container--content--action--select--label"
                               :class="{'disable-label' : isChecked}"
                               v-html="checkboxCopy"/>
                        </div>
                        <button class="btn btn--primary addon--container--content--action--button"
                                @click="submit" v-html="$t('FREDDIES_ADDONS_NEXT')">
                        </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { SECTION_FREDDIES_ADDONS, PRODUCT_TYPE_BUMPER_SINGLE, PRODUCT_TYPE_POP_SINGLE } from '@/constants/Gifting';
import { capitalizeFirstLetter } from '@/helpers/StringHelpers';

export default {
    name: 'FreddiesAddons',
    methods: {
        submit() {
            this.$store.commit('gifting/setSectionComplete', SECTION_FREDDIES_ADDONS);
            this.$router.push({ name: 'account.gifting.delivery-day' });
        },
    },
    computed: {
        ...mapGetters({
            address: 'address/getSelectedGiftingAddress',
            selectedBoxName: 'gifting/getSelectedBoxName',
            isFreeVase: 'account/isFreeVase',
            hurricaneVasePrice: 'gifting/getHurricaneVasePrice',
            paidVasePrice: 'gifting/getPaidVasePrice',
            opticVasePrice: 'gifting/getOpticVasePrice',
            currency: 'localisation/getCurrency',
        }),
        getImageUrl() {
            if (this.isPopSelected) return 'https://freddiesflowers-marketing-assets.s3.eu-west-2.amazonaws.com/images/shop/WEB+READY/Optic+Vase/OpticV_MAIN.jpg';
            return this.isBumperSelected ? 'https://freddiesflowers-com.s3.eu-west-2.amazonaws.com/images/shop/showstopper/SHOWSTOPPER_MAIN.jpg' : require('@/assets/images/pages/vase/vase.jpg');
        },
        isBumperSelected() {
            return this.selectedBoxName === PRODUCT_TYPE_BUMPER_SINGLE;
        },
        isPopSelected() {
            return this.selectedBoxName === PRODUCT_TYPE_POP_SINGLE;
        },
        firstName() {
            return capitalizeFirstLetter(this.address.first_name);
        },
        vasePrice() {
            if (this.isPopSelected) return `${this.currency}${this.opticVasePrice}`;
            return this.isBumperSelected ? `${this.currency}${this.hurricaneVasePrice}` : `${this.currency}${this.paidVasePrice}`;
        },
        vaseName() {
            if (this.isPopSelected) return this.$t('OPTIC_VASE');
            return this.isBumperSelected ? this.$t('SHOWSTOPPER_VASE') : this.$t('Classic_VASE');
        },
        checkboxCopy() {
            if (this.isChecked && !this.isPopSelected) return this.$t('FREDDIES_ADDONS_CHECKBOX_COPY_FREE', { vasePrice: this.vasePrice, vaseName: this.vaseName });
            return this.$t('FREDDIES_ADDONS_CHECKBOX_COPY', { vasePrice: this.vasePrice, vaseName: this.vaseName });
        },
        paidVase: {
            get() {
                return this.$store.getters['gifting/isPaidVaseAttached'];
            },
            set(value) {
                this.$store.commit('gifting/setAddonVase', value);
            },
        },
        isChecked() {
            return this.isFreeVase && !this.isPopSelected;
        },
    },
};
</script>

<style lang="scss" scoped>
.addon {
    &--container {
        padding: 20px;
        margin: 0 auto;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 1024px;
        gap: 20px;
        @media (max-width: 768px) {
            flex-direction: column;
        }
        &--content {
            margin: 0 auto;
            &--text {
                width: 90%;
                margin: 0 auto;
                &--disc, &--title {
                    text-align: center;
                }
            }
            &--action {
                margin: 20px auto;
                padding: 20px 0;
                border: 1px solid #e2e8f0;
                &--select {
                    display: flex;
                    width: 90%;
                    margin: auto;
                    align-items: center;
                    justify-content: center;
                    &--input {
                        margin: 20px;
                        transform: scale(1.5);
                    }
                    &--label {
                        margin-left: 0;
                    }
                }
                &--button {
                    min-width: fit-content;
                    width: 80%;
                    display: block;
                    margin: 0 auto;
                }
            }
        }
    }
}
.disable-label {
    pointer-events: none;
}
</style>
